import React, { useContext } from 'react'
import { TextField } from "@mui/material"
import { LoadingContext } from '../M_Utils'
import { useTranslation } from 'react-i18next'

export function M_TextArea({ label, value, required, disabled, color,
    secondColor, rows, helperText, onChange, size, margin, translate }) {
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()
    
    color = color ? color : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'
    secondColor = secondColor ? secondColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'

    return (<TextField
        sx={{
            margin: margin,
            width: size ? size : null,
            '& label': { color: secondColor ? secondColor : 'var(--color-black)' },
            '& label.Mui-focused': { color: secondColor ? secondColor : 'var(--color-black)' },
            '& .MuiInput-underline:after': { borderBottomColor: color ? color : 'var(--color-black)' },
            "& .MuiInputBase-root.Mui-disabled": {
                "& > fieldset": {
                    borderColor: 'rgba(0, 0, 0, 0.38) !important'
                }
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: color ? color : 'var(--color-black)',
                },
                '&:hover fieldset': {
                    borderColor: color ? color : 'var(--color-black)',
                },
                '&.Mui-focused fieldset': {
                    borderColor: color ? color : 'var(--color-black)',
                },
                "& legend": {
                    letterSpacing: -1.9
                }
            }
        }}
        margin="dense"
        required={required}
        disabled={disabled}
        fullWidth
        variant="outlined"
        slotProps={{
            inputLabel:{ autoComplete: "none", shrink: true }
        }}
        label={translate && t(label) || label}
        value={value}
        onChange={onChange}
        multiline
        rows={rows ? rows : 3}
        helperText={helperText}
    />
    )
}